export default "__VITE_ASSET__BUUMvgI2__"